/**
 * SAML Callback — exchanges one-time token for JWT.
 * Reached after ACS redirects to /auth/callback/saml?token=<otp>
 */
import { useEffect, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import apiClient from '@/lib/apiClient'
import { useAuthStore } from '@/store/authStore'
import { rutaTrasLogin } from '@/modules/auth/rutaTrasLogin'

export function SAMLCallbackPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { setTokens, setTenants } = useAuthStore()
  const processed = useRef(false)

  useEffect(() => {
    if (processed.current) return
    processed.current = true

    const token = searchParams.get('token')
    if (!token) {
      navigate('/auth/saml-error?code=missing_token', { replace: true })
      return
    }

    apiClient.get(`/auth/saml/callback/?token=${encodeURIComponent(token)}`)
      .then(res => {
        const data = res.data
        // JWT slim: identidad del token + tenants/permisos del response body
        setTokens(data.access)
        if (data.tenants?.length) {
          setTenants(data.tenants)
        }
        // Sin la lista de empresas en la respuesta, se sigue como antes: al
        // inicio, que el guard resuelve.
        navigate(data.tenants?.length
          ? rutaTrasLogin({ tenants: data.tenants, user: data.user ?? {} })
          : '/dashboard', { replace: true })
      })
      .catch(() => {
        navigate('/auth/saml-error?code=callback_failed', { replace: true })
      })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center bg-auth">
      <div className="text-center">
        <Loader2 size={40} className="animate-spin text-white mx-auto mb-4" />
        <p className="text-white text-sm">Autenticando con SSO…</p>
      </div>
    </div>
  )
}
